import { Component } from "vue-property-decorator";
import { BaseComponent } from "@/app/BaseComponent";
import { HOD_ONBOARDING_ROOT_LOCATION } from "@/modules/onboarding/hod/workflow";

@Component
export class BaseHodOnboardingPage extends BaseComponent {
    onboardingRootLink = HOD_ONBOARDING_ROOT_LOCATION;
}
